// removed by extract-text-webpack-plugin
module.exports = {"backLink":"header__backLink--a1975f12","icons":"header__icons--b2bef834","headerShareButton":"header__headerShareButton--f0306d3e","headerResetButton":"header__headerResetButton--db8490bb"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/header.scss
// module id = 311
// module chunks = 0